import { Node } from "@tiptap/pm/model";
import { EditorView } from "@tiptap/pm/view";
import { yXmlFragmentToProsemirrorJSON } from "y-prosemirror";

import { django } from "@/api";

import ListItem from "../ListItem";
import { convertXmlToYjs } from "./xmlToYjsConverter";

export const findListItemFromEventTarget = (
  target: Element,
  view: EditorView
): [Node | null, number | null] => {
  let pos = view.posAtDOM(target, 1);
  const resolvedPos = view.state.doc.resolve(pos);

  for (let depth = resolvedPos.depth; depth > 0; depth--) {
    const node = resolvedPos.node(depth);
    if (node.type.name === ListItem.name) {
      return [node, resolvedPos.before(depth)];
    }
  }

  return [null, null];
};

const collapsedStore = () => {
  let items: string | null = localStorage.getItem("disco-collapsed");
  let parsedItems: { [key: string]: boolean } = {};
  if (!items) {
    parsedItems = {};
  } else {
    parsedItems = JSON.parse(`${items}`);
  }
  return parsedItems;
};

export const storeCollapsed = (id: string, collapsed: boolean) => {
  const items = collapsedStore();
  items[id] = collapsed;
  localStorage.setItem("disco-collapsed", JSON.stringify(items));
};

export const getCollapsed = (id: string) => {
  const items = collapsedStore();
  return id in items ? items[id] : false;
};

const syncedCollapsedStore = () => {
  let items: string | null = localStorage.getItem("disco-syncedCollapsed");
  let parsedItems: { [key: string]: boolean } = {};
  if (!items) {
    parsedItems = {};
  } else {
    parsedItems = JSON.parse(`${items}`);
  }
  return parsedItems;
};

export const storeSyncedCollapsed = (id: string, syncedCollapsed: boolean) => {
  const items = syncedCollapsedStore();
  items[id] = syncedCollapsed;
  localStorage.setItem("disco-syncedCollapsed", JSON.stringify(items));
};

export const getSyncedCollapsed = (id: string) => {
  const items = syncedCollapsedStore();
  return id in items ? items[id] : true;
};

export const findChildOfType = (node: Node, type: string) => {
  for (let i = 0; i < node.childCount; i++) {
    const child = node.child(i);
    if (child.type.name === type) {
      return child;
    }
  }

  return null;
};

export const getSyncedNodeData = async (projectId: string, blockId: string) => {
  const response = await django.get(`editor/node/${projectId}/`, {
    params: {
      format: "json",
      block: blockId,
    },
  });
  const xmlFragment = convertXmlToYjs(response.data);
  const editorJson = yXmlFragmentToProsemirrorJSON(xmlFragment);
  const mainLabel = editorJson.content[0].content[0].content.map((item) => item.text).join(" ");
  return mainLabel;
};
